import { useTestStore } from "../../../hooks/store";
import Styles from "./TestStyles.module.css";
import { TestSection } from "../../../components/Test";
import { ClickAwayListener } from "@mui/material";
import { BrowserRouter, useBlocker } from "react-router";

export default function Test() {
  return (
    <main className={Styles.test}>
      <TestSection />
    </main>
  );
}
